export const TECHNOLOGY_TYPE = {
	COMPUTERIZED_NUMERIC_CONTROL: 1,
	ADDITIVE_MANUFACTURING: 2,
	LASER: 3,
	VACUUM_CASTING: 4,
	INJECTION_MOLD: 5,
}
